"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDate = exports.fromTimestampToDate = exports.monthNamesLong = exports.monthNamesShort = exports.monthNameFullToIndex = exports.monthNameShortToIndex = exports.getMonthYear = exports.getMonth = exports.getYear = exports.calcAge = exports.dateFormatCustom = exports.convertDateToIso = exports.convertDateToBr = exports.isValidDate = exports.isValidFormatToParse = exports.dateParser = void 0;
/** @module dateParser */
/* eslint-disable no-prototype-builtins */
const date_fns_1 = require("date-fns");
const pt_BR_1 = require("date-fns/locale/pt-BR");
const localeConfig = { locale: pt_BR_1.default };
const isoPattern = /^\d{4}-\d{2}-\d{2}((\s|T|t)?(\d{1,2}:?)+)?/;
const brPattern = /^\d{2}\/\d{2}\/\d{4}$/;
const monthsShortMap = {
    0: 'JAN',
    1: 'FEV',
    2: 'MAR',
    3: 'ABR',
    4: 'MAI',
    5: 'JUN',
    6: 'JUL',
    7: 'AGO',
    8: 'SET',
    9: 'OUT',
    10: 'NOV',
    11: 'DEZ',
};
const monthsFullMap = {
    0: 'Janeiro',
    1: 'Fevereiro',
    2: 'Março',
    3: 'Abril',
    4: 'Maio',
    5: 'Junho',
    6: 'Julho',
    7: 'Agosto',
    8: 'Setembro',
    9: 'Outubro',
    10: 'Novembro',
    11: 'Dezembro',
};
const hasToDate = (dateValue) => {
    // sei la por que nao funfa fora do if
    if (dateValue && dateValue.hasOwnProperty('toDate')) {
        return true;
    }
    return false;
};
const isFirestoreTimeStampLike = (ts) => {
    if (!ts) {
        return false;
    }
    return ((ts.hasOwnProperty('seconds') && ts.hasOwnProperty('nanoseconds')) ||
        (ts.hasOwnProperty('_seconds') && ts.hasOwnProperty('_nanoseconds')));
};
const isString = (dateValue) => typeof dateValue === 'string';
const isNumber = (dateValue) => typeof dateValue === 'number';
const isPatternISO = (dateValue) => isoPattern.test(dateValue);
const isPatternBR = (dateValue) => brPattern.test(dateValue);
const customFormater = (dateValue, dateFormat) => {
    const date = exports.dateParser(dateValue);
    return exports.isValidDate(date) ? date_fns_1.format(exports.dateParser(dateValue), dateFormat, localeConfig) : '';
};
const fromFirestoreToDate = (ts) => {
    let date, seconds;
    if (ts.seconds) {
        seconds = ts.seconds;
    }
    else if (ts._seconds) {
        seconds = ts._seconds;
    }
    date = new Date(seconds * 1000);
    return date;
};
/**
 * @param {DateLike} dateValue string precisa estar no formato YYYY-MM-DD ou DD/MM/YYYY ou timestamp do firebase
 * @return {Date|undefined}
 */
exports.dateParser = (dateValue) => {
    let date = new Date('date not provided');
    if (exports.isValidDate(dateValue)) {
        date = dateValue;
    }
    else if (hasToDate(dateValue)) {
        date = dateValue.toDate();
    }
    else if (isFirestoreTimeStampLike(dateValue)) {
        date = fromFirestoreToDate(dateValue);
    }
    else if (isNumber(dateValue)) {
        date = new Date(dateValue);
    }
    else if (isPatternISO(dateValue)) {
        date = new Date(dateValue);
    }
    else if (isPatternBR(dateValue)) {
        date = date_fns_1.parse(dateValue, 'dd/MM/yyyy', new Date());
    }
    // console.log('parser', date)
    return date;
};
exports.default = exports.dateParser;
exports.isValidFormatToParse = (dateValue) => {
    return (isString(dateValue) ||
        isNumber(dateValue) ||
        exports.isValidDate(dateValue) ||
        hasToDate(dateValue) ||
        isFirestoreTimeStampLike(dateValue) ||
        isPatternISO(dateValue) ||
        isPatternBR(dateValue));
};
exports.isValidDate = (dateValue) => {
    return dateValue instanceof Date && !isNaN(dateValue.getTime());
};
/**
 * @param {DateLike} dateValue
 * @param {boolean} withTime
 * @return {string}
 */
exports.convertDateToBr = (dateValue, withTime = false, type = 'full') => {
    let dateFormat = 'dd/MM/yyyy';
    if (type === 'short') {
        dateFormat = 'dd/MM';
    }
    if (type === 'month_year') {
        dateFormat = 'MMM/yy'; // exemplo: Fev/22
    }
    let timeFormat = '';
    if (withTime) {
        timeFormat = ' HH:mm';
    }
    return customFormater(dateValue, dateFormat + timeFormat);
};
exports.convertDateToIso = (dateValue, withTime = true) => {
    let formatText = 'yyyy-MM-dd';
    if (withTime) {
        formatText += ' HH:mm:ss';
    }
    return customFormater(dateValue, formatText);
};
exports.dateFormatCustom = (dateValue, dateFormat) => {
    return customFormater(dateValue, dateFormat);
};
exports.calcAge = (date) => date_fns_1.differenceInYears(Date.now(), exports.toDate(exports.dateParser(date)));
exports.getYear = (date) => date.getFullYear();
exports.getMonth = (date, type = 'short') => {
    if (!date)
        return '';
    if (type === 'short') {
        return monthsShortMap[date.getMonth()];
    }
    else {
        return monthsFullMap[date.getMonth()];
    }
};
exports.getMonthYear = (date) => {
    if (!date)
        return '';
    return `${exports.getMonth(date, 'full')} ${exports.getYear(date)}`;
};
const monthNameToIndex = (monthName, source) => {
    const entries = Object.entries(source);
    const entry = entries.find(([index, name]) => name.toLowerCase() === monthName.toLowerCase());
    return entry ? Number(entry[0]) : -1;
};
exports.monthNameShortToIndex = (monthName) => monthNameToIndex(monthName, monthsShortMap);
exports.monthNameFullToIndex = (monthName) => monthNameToIndex(monthName, monthsFullMap);
exports.monthNamesShort = Object.assign({}, monthsShortMap);
exports.monthNamesLong = Object.assign({}, monthsFullMap);
/**
 * @deprecated use dateParser instead
 */
exports.fromTimestampToDate = fromFirestoreToDate;
/**
 * @deprecated
 */
exports.toDate = (date) => {
    let finalDate;
    if (!date) {
        finalDate = new Date(0);
    }
    else {
        finalDate = date;
    }
    return finalDate;
};
//# sourceMappingURL=index.js.map